// src/pages/admin/AdminActivity.js
// Superadmin audit log: every approval, suspension, deletion, etc., newest first.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { adminAPI } from '../../utils/api';
import { ACTION_LOG_LABEL, errorOf, fmtDate } from './common';

const LIMIT = 30;

export default function AdminActivity() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);

  useEffect(() => {
    adminAPI.actions({ page, limit: LIMIT }).then(r => setData(r.data)).catch(err => toast.error(errorOf(err, 'Could not load the activity log')));
  }, [page]);

  const pages = data ? Math.max(1, Math.ceil(data.total / LIMIT)) : 1;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="page-header">
        <div>
          <div className="page-title">Activity log</div>
          <div className="page-subtitle">Everything done from the admin panel</div>
        </div>
      </div>
      <div className="toolbar">
        <span className="count-text ml-auto">{data ? `Page ${page} of ${pages} · ${data.total} entries` : ''}</span>
        <button className="btn btn-outline" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>‹ Prev</button>
        <button className="btn btn-outline" disabled={page >= pages} onClick={() => setPage(p => p + 1)}>Next ›</button>
      </div>
      <div style={{ flex: 1, overflow: 'auto' }}>
        {!data ? <div className="loading-center"><div className="spinner" /></div> :
          data.actions.length === 0 ? (
            <div className="empty-state"><span style={{ fontSize: 40 }}>🗒</span><h3>Nothing yet</h3><p>Approvals, suspensions and other admin actions will appear here.</p></div>
          ) : (
            <table className="data-table" style={{ minWidth: 640 }}>
              <thead><tr><th style={{ width: 'auto' }}>When</th><th>Action</th><th>Organization / user</th><th>Reason</th><th>By</th></tr></thead>
              <tbody>
                {data.actions.map(a => (
                  <tr key={a.id}>
                    <td style={{ whiteSpace: 'nowrap', width: 'auto' }}>{fmtDate(a.created_at)}</td>
                    <td style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{ACTION_LOG_LABEL[a.action] || a.action}</td>
                    <td>
                      {a.target_exists
                        ? <span style={{ color: '#0f766e', cursor: 'pointer', fontWeight: 500 }}
                            onClick={() => navigate(a.action.startsWith('org_') ? `/admin/organizations?status=all&org=${a.target_org_id}` : `/admin/users?status=all&user=${a.target_user_id}`)}>{a.target_name}</span>
                        : <span>{a.target_name} <span style={{ color: '#aaa' }}>(deleted)</span></span>}
                      <div style={{ color: '#8892a4', fontSize: 11 }}>{a.target_email}</div>
                    </td>
                    <td style={{ color: a.reason ? '#4a5568' : '#aaa', maxWidth: 280 }}>{a.reason || '—'}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{a.admin_name || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
      </div>
    </div>
  );
}
